/* eslint-disable @typescript-eslint/no-use-before-define */
import Cookies from 'universal-cookie';
import { useQuery, useMutation } from '@apollo/client';
import { NextRouter, useRouter } from 'next/router';
import { IGroupParam, IFlightData } from 'detail/types';
import {
  AddFavoriteMutation,
  AddFavoriteMutationVariables,
  GetFavoriteQuery,
  GetFavoriteQueryVariables,
  DeleteFavoriteMutation,
  DeleteFavoriteMutationVariables,
} from 'types/apollo';

import ADD_FAVORITE from './addFavorite.gql';
import GET_FAVORITE from './getFavorite.gql';
import DELETE_FAVORITE from './deleteFavorite.gql';

const cookies = new Cookies();

const useFavorite = (
  flightData: IFlightData,
  groupParam: IGroupParam,
  errorMsg: string,
  successMsg: string,
) => {
  const { data } = useQuery<GetFavoriteQuery, GetFavoriteQueryVariables>(
    GET_FAVORITE,
    { variables: { flightData } },
  );
  const isFav = !!data?.favorite.id && !data?.favorite.isDeleted;
  const [mutationAddFavorite] = useMutation<
    AddFavoriteMutation,
    AddFavoriteMutationVariables
  >(ADD_FAVORITE, {
    onCompleted(data) {
      if (data?.addFavoriteV2) {
        alert(successMsg);
      } else {
        alert(errorMsg);
      }
    },
    onError() {
      alert(errorMsg);
    },
  });
  const [mutationDeleteFavorite] = useMutation<
    DeleteFavoriteMutation,
    DeleteFavoriteMutationVariables
  >(DELETE_FAVORITE);

  const router = useRouter();
  let timeId = 0;

  const addFavorite = () => {
    mutationAddFavorite({ variables: { flightData, groupParam } });
  };

  const deleteFavorite = () => {
    if (data?.favorite.id) {
      mutationDeleteFavorite({ variables: { ids: [data.favorite.id] } });
    }
  };

  const addFavoriteAfterLogin = () => {
    // 로그인후 실행
    removeLoginEvent(router);
    addFavorite();
  };

  const addLoginEvent = (_router: NextRouter) => {
    // 로그인후 호출될 이벤트 등록
    removeLoginEvent(_router);
    window.clearTimeout(timeId);
    _router.events.on('loginSuccess' as any, addFavoriteAfterLogin);
    timeId = window.setTimeout(() => {
      removeLoginEvent(_router);
    }, 60 * 1000);
  };

  const removeLoginEvent = (_router: NextRouter) => {
    // 로그인후 호출될 이벤트 제거
    _router.events.off('loginSuccess' as any, addFavoriteAfterLogin);
  };

  const handleFavorite = () => {
    const loginCookie = cookies.get('NID_SES');
    if (!loginCookie) {
      alert('로그인 후 이용해 주시기 바랍니다.');
      addLoginEvent(router);
      const url = encodeURIComponent(`${window.origin}/flights/addFavorite`);
      window.open(
        `https://nid.naver.com/nidlogin.login?mode=form&url=${url}`,
        '_blank',
      );
      return;
    }
    if (!isFav) {
      addFavorite();
    } else {
      deleteFavorite();
    }
  };

  return { isFav, handleFavorite };
};

export default useFavorite;
